import type { AuthConfig, AuthLegalLink } from "@huub-web/auth";
import { parsePasswordStrengthLevel } from "@huub-web/auth";
import type { ThemeName } from "@huub-web/ui";

const API_BASE_ENDPOINT = import.meta.env.VITE_API_BASE_ENDPOINT ?? "";

const LEGAL_LINKS_BY_THEME: Partial<Record<ThemeName, AuthLegalLink[]>> = {
  verenigingEigenHuis: [
    {
      labelKey: "authScreens.legalLinks.privacyStatement",
      url: "https://www.eigenhuis.nl/privacystatement",
    },
    {
      labelKey: "authScreens.legalLinks.termsAndConditions",
      url: "https://www.eigenhuis.nl/algemene-voorwaarden",
    },
  ],
};

const theme = (import.meta.env.VITE_THEME as ThemeName) || "light";

/**
 * Auth configuration for the Vite app.
 * Reads from Vite environment variables.
 */
export const authConfig: AuthConfig = {
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN ?? "",
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? "",
    redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI ?? "",
    audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? "",
  },
  api: {
    verifyTokenEndpoint: `${API_BASE_ENDPOINT}/auth/verify`,
  },
  cookie: {
    name: import.meta.env.VITE_AUTH_COOKIE_NAME ?? "huub_id_token",
    domain: import.meta.env.VITE_AUTH_COOKIE_DOMAIN || undefined,
  },
  passwordStrengthLevel: parsePasswordStrengthLevel(
    import.meta.env.VITE_PASSWORD_STRENGTH_LEVEL,
  ),
  legalLinks: LEGAL_LINKS_BY_THEME[theme],
};

/**
 * Whether the Vite app uses in-app auth (whitelabel) or external auth (marketing site).
 */
export const AUTH_MODE =
  (import.meta.env.VITE_AUTH_MODE as "internal" | "external") ?? "external";
